'use client';

import { Slot } from '@radix-ui/react-slot';
import { ReactNode } from 'react';

import Modal from '@/components/Modal';
import Paper from '@/components/Paper';
import { cn } from '@/utils/twx';

import Button from '../Button';

interface AlertProps {
  isOpen: boolean;
  close: () => void;
  title: ReactNode;
  subTitle?: ReactNode;
  extra?: ReactNode;
  confirmText?: string;
  allowOutsideClickClose?: boolean;
  allowEscClose?: boolean;
  backgroundClassName?: string;
  bgClassName?: string;
  confirmAction?: () => void;
  bottomComponent?: ReactNode;
  /**
   * 시안이 공용 알럿과 다른 화면에서만 쓰는 override.
   * 기본값이 종전 클래스 그대로라 넘기지 않으면 모양이 바뀌지 않는다 — 64개 사용처 부작용 0.
   * cn(=twMerge) 이 뒤에 온 클래스를 채택하므로 충돌 항목(폰트/여백/폭)이 그대로 덮인다.
   */
  titleClassName?: string;
  subTitleClassName?: string;
  confirmWrapperClassName?: string;
  confirmButtonClassName?: string;
}

const AlertV2 = ({
  isOpen,
  close,
  confirmText = '확인',
  title = '',
  subTitle = '',
  extra = '',
  backgroundClassName = '',
  bgClassName,
  allowOutsideClickClose = true,
  allowEscClose = true,
  confirmAction,
  bottomComponent,
  titleClassName,
  subTitleClassName,
  confirmWrapperClassName,
  confirmButtonClassName,
}: AlertProps) => {
  const handleClose = () => {
    if (confirmAction) confirmAction();
    close();
  };

  const handleConfirm = () => {
    handleClose();
  };
  return (
    <Modal
      isOpen={isOpen}
      close={handleClose}
      allowOutsideClickClose={allowOutsideClickClose}
      allowEscClose={allowEscClose}
      bgClassName={bgClassName}
    >
      <Paper
        className={cn(
          'min-w-[343px] rounded-[30px] w-[343px] break-keep *:text-balance',
          !!extra && 'bg-[#F7F7F7]',
          backgroundClassName,
        )}
      >
        <p
          className={cn(
            'text-[20px] font-semibold text-center whitespace-pre-line break-words',
            titleClassName,
          )}
        >
          {title}
        </p>
        {!!subTitle && (
          <div className={cn('mt-2.5 text-[14px] text-gray-2 text-center', subTitleClassName)}>
            {subTitle}
          </div>
        )}
        {!!extra && (
          <div className="px-2 mt-7">
            <div className="rounded-2xl bg-white py-5 justify-center flex text-primary font-semibold items-center text-center">
              {extra}
            </div>
          </div>
        )}
        {!!confirmText && (
          <div className={cn('mt-7 flex justify-center gap-2.5', confirmWrapperClassName)}>
            <Button
              variant={'tonalgray'}
              onClick={handleConfirm}
              className={cn('w-[136px] bg-gray-7', confirmButtonClassName)}
              size="sm"
            >
              {confirmText}
            </Button>
          </div>
        )}
        {bottomComponent && (
          <div className="mt-3.5 flex justify-center">
            <Slot onClick={handleClose}>{bottomComponent}</Slot>
          </div>
        )}
      </Paper>
    </Modal>
  );
};

export default AlertV2;
